import { Card, Text, cn } from '@growtherapy/sprout-ui';

import { keep } from '../../utils';
import { IntakeFormAnswer } from './IntakeFormAnswer';
import { GroupedFormData, QuestionTypeEnum } from './types';

type IntakeFormSectionProps = {
  selectedForm: GroupedFormData;
};

export function IntakeFormSection({ selectedForm }: IntakeFormSectionProps) {
  return (
    <div className='flex flex-col' data-testid='client-information.forms.intake-form'>
      {Object.entries(selectedForm.formQuestionsWithAnswers).map(([sectionTitle, questions]) => (
        <Card
          key={sectionTitle}
          title={sectionTitle}
          className='font-medium pb-2 fs-exclude rebrand:bg-surface-inverseEmphasis'
          titleClassName='rebrand:text-text-inverse'
          data-dd-privacy='mask'
        >
          {keep(questions, (question, i) => {
            const answer = question.answer;

            if (!answer) return null;

            const isDivider = question.type === QuestionTypeEnum.DIVIDER;
            const isSectionTitle = question.type === QuestionTypeEnum.SECTION_TITLE;

            const isFlexAnswer = answer === 'Yes' || answer === 'No';
            return (
              <div className='fs-exclude' data-dd-privacy='mask' key={`${question.question}-${i}`}>
                {isDivider ? (
                  <hr className='w-full mb-4 mt-4 text-neutral-400 rebrand:text-border-default' />
                ) : (
                  <div className={cn('py-3', { 'flex flex-row justify-between': isFlexAnswer })}>
                    <Text
                      className={cn('rebrand:text-text-inverse', {
                        'font-semibold font-large mt-4 pt-4 mb-4': isSectionTitle,
                        'font-medium': !isSectionTitle,
                      })}
                    >
                      {question.question}
                    </Text>
                    <IntakeFormAnswer questionWithAnswer={question} />
                  </div>
                )}
              </div>
            );
          })}
        </Card>
      ))}
    </div>
  );
}
